import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { ServiceInfoModal } from '../../containers/UserSettingsPage/styles';
import { withTranslation } from 'react-i18next';
import { STORAGE_CONFIG_MODAL as trans } from './translationValues';

const NAMESPACE = ['STORAGE_CONFIG_MODAL'];
const ServiceConfigForm = props => {
  const {
    selectedService,
    servicesList,
    onCancel,
    handleAddUpdateService,
    awaitingApiResponse,
    t,
  } = props;
  const { getFieldDecorator, setFieldsValue } = props.form;

  const [isNewService, setIsNewService] = useState(false);
  const displayText = {
    accessKey: t(trans.ACCESS_KEY_LABEL.key, trans.ACCESS_KEY_LABEL.value),
    secretKey: t(trans.SECRET_KEY_LABEL.key, trans.SECRET_KEY_LABEL.value),
  };

  useEffect(() => {
    const newService = Object.values(selectedService.credentials).every(value => value === null);
    setIsNewService(newService);
    let values = {};
    Object.entries(selectedService.credentials).map(([key, value]) => (values[key] = value));
    setFieldsValue(values);
  }, []);

  const handleInputChange = fieldName => e => {
    setFieldsValue({ [fieldName]: e.target.value });
  };

  const validations = [
    {
      required: true,
      message: t(trans.FORM_FIELD_REQUIRED_ERROR_MESSAGE.key, trans.FORM_FIELD_REQUIRED_ERROR_MESSAGE.value),
    },
  ];

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFields(async (err, values) => {
      if (!err) {
        if (JSON.stringify(selectedService.credentials) === JSON.stringify(values)) {
          message.warn(t(trans.NO_CHANGES_MADE_WARNING.key, trans.NO_CHANGES_MADE_WARNING.value));
          return;
        }
        let payload = selectedService;
        selectedService.credentials = values;
        handleAddUpdateService(payload, true);
      }
    });
  };
  return (
    <ServiceInfoModal
      visible={selectedService}
      title={`${!isNewService ? t(trans.UPDATE_TITLE.key, trans.UPDATE_TITLE.value)+' ' : ''} ${
        servicesList.find(service => service.name === selectedService.name)?.label
      } ${' '+t(trans.CONFIG_TITLE.key, trans.CONFIG_TITLE.value)}`}
      footer={[
        <Button loading={awaitingApiResponse} type="primary" onClick={handleSubmit}>
          {isNewService ? t(trans.SUBMIT_BUTTON.key, trans.SUBMIT_BUTTON.value) : t(trans.UPDATE_TITLE.key, trans.UPDATE_TITLE.value)}
        </Button>,
      ]}
      onCancel={onCancel}
    >
      <Form>
        {Object.entries(selectedService.credentials).map(([key, value], index) => (
          <Form.Item label={displayText[key] ? displayText[key] : key}>
            {getFieldDecorator(key, {
              rules: validations,
            })(
              <Input
                size="large"
                value={value}
                onChange={handleInputChange}
                autoFocus={index === 0 && isNewService}
              />,
            )}
          </Form.Item>
        ))}
      </Form>
    </ServiceInfoModal>
  );
};

const ServiceDetailsModal = Form.create({ name: 'service_config_form' })(ServiceConfigForm);
export default withTranslation(NAMESPACE)(ServiceDetailsModal);